import React, { useState } from "react";
import { useEffect } from "react";
import { OverlayTrigger } from "react-bootstrap";
import { BsInfoCircle } from "react-icons/bs";
import { NumberInput } from "./NumberInput";
import { PhoneInputComponent } from "./PhoneInputComponent";
// import Dropdown from "./DilDropdown";
import { TooltipStandard } from "./TooltipStandard";
export const DiliTextCP = ({
  children,
  helperText,
  invalidText,
  type,
  value,
  name,
  validationTest,
  wasSubmitted,
  onChange,
  onBlur,
  label,
  className,
  inputClass,
  labelClass,
  helperTextClass,
  required,
  style,
  inputStyle,
  labelStyle,
  helperTextStyle,
  loading,
  showProblemText,
  showProblemTextOnlyAfterStartedTyping,
  showHelperText,
  problemText,
  validationTestOnBlur = false,
  successfulSubmissionNotif: successfulSubmissionOrResetNotif,
  //Only use 1 of the two following
  displayTextAreaCharacterCount, //shows a character count for textareas. Use this one if you pass bootstrap col as a className
  displayTextAreaCharacterCountNotCol, // use this one if not.
  infoText,
  infoTextIconFloatRight, //boolean for whether we should make the info text icon float to the right
  ...props // i have passed the rest of the props onto the inputs and not the container div, let me know if we should refactor
}) => {
  //   console.log(value);
  const [startedTyping, setStartedTyping] = useState(false);
  const [wasBlurred, setWasBlurred] = useState(false);
  const [comboboxInput, setComboboxInput] = useState("");
  const handleChange = (e) => {
    onChange && onChange(e); // if an onchange function was passed, call it. If it wasn't passed and we try to call it, the page will break, but we probably should always pass one in honestly if using this component.
    if (!startedTyping) {
      setStartedTyping(true);
    }
  };
  const handleBlur = (e) => {
    onBlur && onBlur(e);
    if (!wasBlurred) {
      setWasBlurred(true);
    }
  };
  // console.log("Dilitextcp was submitted: " + wasSubmitted);
  // console.log("Dilitextcp started typing: " + startedTyping);
  //if no validation test function was passed in, set it to always return true

  validationTest =
    validationTest ??
    (required
      ? (value) => {
          //   console.log("default validation if input is required");
          return (
            ("" + value)?.length > 0 || // for required number inputs, if giving an initial value. seems to be fine if user types themselves
            (validationTestOnBlur
              ? !wasBlurred && !wasSubmitted
              : !startedTyping && !wasSubmitted)
          ); //added the short circuit so that it would not crash in case no value was passed in. However, if no value is passed in, it will always be in an invalid state for now. We would have to manage state internally with the option to manage externally to allow the component to be used more flexibly. I think we did it like that in cascade but for now I think it is fine to just use this the way it is. We are controlling state in the parent anyway as we are not facing the lag issues we did in cascade currently.
        }
      : () => true);
  const isValid =
    validationTest(value) ||
    (validationTestOnBlur
      ? !wasBlurred && !wasSubmitted
      : !startedTyping && !wasSubmitted);

  const showProblemTextHelper = showProblemTextOnlyAfterStartedTyping
    ? showProblemText && startedTyping
    : showProblemText;

  useEffect(() => {
    setStartedTyping(false);
    setWasBlurred(false);
  }, [successfulSubmissionOrResetNotif]);

  return (
    //previously className appended form-group but I didn't want that on some inputs so I took it out.
    //I think all form-group does is add some margin-bottom but I may be wrong
    <div
      className={className}
      style={{
        position: "relative", // for character count display,
        ...style,
      }}
    >
      {label && (
        <label
          style={{
            width: "100%",
            ...labelStyle,
          }}
          className={(labelClass ?? "") + (isValid ? "" : " text-danger")}
        >
          {label}
          {required ? <span className="required-star">*</span> : ""}
          {infoText && (
            <OverlayTrigger
              placement="top"
              flip
              overlay={<TooltipStandard>{infoText}</TooltipStandard>}
            >
              <div
                style={{
                  display: "inline",
                  float: infoTextIconFloatRight ? "right" : "",
                }}
              >
                {" "}
                <BsInfoCircle className="info-circle-color" />
              </div>
            </OverlayTrigger>
          )}
          {loading && (
            <>
              {" "}
              <div
                className="spinner-border spinner-border-sm text-secondary ml-1"
                role="status"
              >
                <span className="sr-only">Loading...</span>
              </div>
            </>
          )}
        </label>
      )}
      {type === "tel" ? (
        <PhoneInputComponent
          onBlur={handleBlur}
          required={required}
          name={name}
          value={value}
          onChange={handleChange}
          style={inputStyle}
          className={
            (inputClass ?? "") +
            " form-control " +
            (isValid ? "" : "border-danger")
          }
          {...props}
        />
      ) : type === "number" ? (
        <NumberInput
          onBlur={handleBlur}
          required={required}
          name={name}
          value={value}
          onChange={handleChange}
          style={inputStyle}
          className={
            (inputClass ?? "") +
            " form-control " +
            (isValid ? "" : "border-danger")
          }
          {...props}
        />
      ) : type === "combobox" ? (
        <div style={{ position: "relative" }}>
          <input
            style={{
              position: "absolute",
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
              opacity: 1,
              zIndex: "500000000",
            }}
            className="form-control"
          />
          <select
            onBlur={handleBlur}
            required={required}
            name={name}
            value={value}
            onChange={handleChange}
            style={inputStyle}
            className={
              (inputClass ?? "") +
              " form-control " +
              (isValid ? "" : "border-danger")
            }
            {...props}
          >
            {children}
          </select>
        </div>
      ) : type === "select" ? (
        <select
          onBlur={handleBlur}
          required={required}
          name={name}
          value={value}
          onChange={handleChange}
          style={inputStyle}
          className={
            (inputClass ?? "") +
            " form-control " +
            (isValid ? "" : "border-danger")
          }
          {...props}
        >
          {children}
        </select>
      ) : type === "dropdown" ? (
        <div>
          {/* <select
            multiselect-search="true"
            onBlur={handleBlur}
            required={required}
            name={name}
            value={value}
            onChange={handleChange}
            style={inputStyle}
            className={
              (inputClass ?? "") +
              " form-control " +
              (isValid ? "" : "border-danger")
            }
            {...props}
          >
            {children}
          </select> */}
          {/* <Dropdown children={children} /> */}
        </div>
      ) : type === "textarea" ? (
        <>
          <textarea
            onBlur={handleBlur}
            required={required}
            name={name}
            value={value}
            onChange={handleChange}
            style={inputStyle}
            className={
              (inputClass ?? "") +
              " form-control textarea-comments " +
              (isValid ? "" : "border-danger")
            }
            {...props}
          ></textarea>
          {displayTextAreaCharacterCount && (
            <div className="textarea-charactercount">
              {value.length}/{props.maxLength}
            </div>
          )}
          {displayTextAreaCharacterCountNotCol && (
            <div className="textarea-charactercount-notcol">
              {value.length}/{props.maxLength}
            </div>
          )}
        </>
      ) : (
        <input
          onBlur={handleBlur}
          required={required}
          name={name}
          value={value}
          onChange={handleChange}
          style={inputStyle}
          className={
            (inputClass ?? "") +
            " form-control " +
            (isValid ? "" : "border-danger")
          }
          type={type}
          {...props}
        />
      )}
      {isValid
        ? helperText &&
          showHelperText &&
          !showProblemTextHelper && (
            <small
              style={helperTextStyle}
              className={helperTextClass + " form-text pl-1"}
            >
              {helperText}
            </small>
          )
        : invalidText && (
            <small
              style={helperTextStyle}
              className={helperTextClass + " form-text pl-1 text-danger"}
            >
              {invalidText}
            </small>
          )}
      {showProblemTextHelper && (
        <small className={helperTextClass + " form-text text-danger pl-1"}>
          {problemText}
        </small>
      )}
    </div>
  );
};
